<template>
  <aside
    class="is-narrow-mobile is-fullheight section is-hidden-mobile has-background-light"
    style="height: 105%;"
  >
    <p class="menu-label is-hidden-touch has-text-black">Navigation</p>
    <ul class="menu-list" style="text-align: start">
      <li>
        <a href="#" :class="{ 'is-active': activeNum == 1 }" @click="changeActiveLink(1)">
          <span class="icon">
            <i class="fa fa-code"></i>
          </span> プログラミング
        </a>
      </li>

      <li>
        <a href="#" :class="{ 'is-active': activeNum == 2 }" @click="changeActiveLink(2)">
          <span class="icon">
            <i class="fa fa-flask"></i>
          </span> 練習
        </a>
      </li>

      <!-- <li>
        <a href="#" :class="{ 'is-active': activeNum == 3 }" @click="changeActiveLink(3)">
          <span class="icon">
            <i class="fa fa-play"></i>
          </span> 対戦
        </a>
      </li> -->
 
      <li>
        <a href="#" :class="{ 'is-active': activeNum == 4 }" @click="changeActiveLink(4)">
          <span class="icon">
            <i class="fa fa-list"></i>
          </span> 対戦・ランキング
        </a>
      </li>
      <li>
        <a href="#" :class="{ 'is-active': activeNum == 5 }" @click="changeActiveLink(5)">
          <span class="icon">
            <i class="fa fa-book"></i>
          </span> ドキュメント
        </a>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  data() {
    return {
      activeNum: 0
    };
  },
  created(){
  },
  methods: {
    changeActiveLink(n) {
      this.activeNum = n;
      if (n == 1) this.$router.push("/");
      if (n == 2) this.$router.push("/practice");
      // if (n == 3) this.$router.push("/battle");
      if (n == 4) this.$router.push("/list");
      if (n == 5) this.$router.push("Document");
    }
  }
};
</script>
<style>

</style>